import { Record } from 'immutable';
import { schema } from 'normalizr';

export const SiteGroupWeatherConfiguration = new Record({
  id: undefined,
  site_group: undefined,
  weather_enabled: undefined,
  weather_enabled_new_sites: undefined,
  weather_range_km: undefined,
  weather_sensitivity: undefined,
  default_schedule: undefined,
  relays: undefined,
  invert_operation: undefined,
});

export const siteGroupWeatherConfigurationSchema = new schema.Entity('siteGroupWeatherConfigurations');

// for reading in nested models, object with { field: schema }
// siteGroupWeatherConfigurationSchema.define({  });
